import React from 'react';

const Glyphicon = ({ glyph, className }) => (
    <span className={`glyphicon glyphicon-${glyph} ${className}`} />
);

export default Glyphicon;
